import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Section = styled.section`
  padding: 0 var(--container-padding) 96px;
`;

const Banner = styled(motion.div)`
  max-width: var(--container-width);
  margin: 0 auto;
  border-radius: 20px;
  padding: 56px 40px;
  text-align: center;
  background: linear-gradient(135deg, #0e6b3c 0%, #0a5a32 100%);
  box-shadow: 0 16px 48px rgba(14, 107, 60, 0.3);
`;

const Title = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(1.65rem, 3.5vw, 2.25rem);
  font-weight: 800;
  color: #fff;
  margin-bottom: 8px;
`;

const Sub = styled.p`
  color: rgba(255, 255, 255, 0.88);
  font-size: 0.95rem;
  margin-bottom: 28px;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  align-items: center;
`;

const BtnWhite = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 28px;
  border-radius: 100px;
  background: #fff;
  color: #0e6b3c;
  font-weight: 700;
  font-family: var(--font-display);
  font-size: 0.9rem;
  text-decoration: none;
`;

const ContactLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border-radius: 100px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: #fff;
  text-decoration: none;
  font-size: 0.88rem;

  i {
    font-size: 1rem;
  }
`;

const HomeCTA = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.15 });

  return (
    <Section ref={ref}>
      <Banner initial={{ opacity: 0, y: 24 }} animate={inView ? { opacity: 1, y: 0 } : {}}>
        <Title>Ready To Start Your Project?</Title>
        <Sub>Let's build something remarkable together. Get a free consultation today.</Sub>
        <Actions>
          <BtnWhite to="/contact">Get Free Consultation <i className="fas fa-arrow-right" /></BtnWhite>
          <ContactLink href="tel:+918500181606"><i className="fas fa-phone" /> Call Us</ContactLink>
          <ContactLink href="https://wa.me/918500181606" target="_blank" rel="noopener noreferrer"><i className="fab fa-whatsapp" /> WhatsApp</ContactLink>
        </Actions>
      </Banner>
    </Section>
  );
};

export default HomeCTA;
